<template>
  <div id="index">
    <Header ref="header"></Header>
    <div class="banner">
      <div>
        <img src="../assets/img/navImg.png" alt="">
      </div>
    </div>
    <!-- 推荐产品 -->
    <div class="index5 productList" :class="morenDiv == false ? 'none':''">
      <div class="index5Box productListBox">
        <!-- 报价搜索 -->
        <!-- <div class="offerSearch">
          <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="input2"></el-input>
          <button type="primary">搜索</button>
        </div> -->
        <ul>
          <li v-for="(item, index) in goodsList" :key="item.id">
            <img :src="item.images" @click="toProductDetails(item.id)" />
            <p @click="toProductDetails(item.id)">{{item.goodName}}&nbsp;{{item.chandi}}</p>
            <p v-show="goodsShowIndex != index"><button @click="showPhone(index)">价格电议</button></p>
            <p class="index5BoxPhoneP" v-show="goodsShowIndex == index">{{item.phone}}</p>
          </li>
        </ul>
      </div>
      <div class="pageBox">
        <el-pagination background layout="prev, pager, next" :currentPage="currentPage" :pageSize ="pageSize" :total="totalNum"  @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
    <div class="footer">
      <div class="foot">
        <ul>
          <li>电话：0558-5858131</li>
          <li>地址：亳州市谯城区亳芜现代产业园区希夷大道与月季路交叉口</li>
          <li>安徽广盛堂中药饮片有限公司 版权所有 免责声明 皖ICP备18026442号</li>
          <li>皖公网安备 3416020200060号</li>
        </ul>
        <img src="../assets/img/footerImg.jpg" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../components/header'
export default {
  components: {
    Header
  },
  data() {
    return {
      morenDiv:true,
      showLogin:true,
      input2:'',
      EWMImg:false,
      EWMButton:true,
      goodsList:[],
      goodsShowIndex:-1,
      currentPage: 1,//默认显示第一页
      pageSize:10,//默认每页显示10条
      totalNum: 100 //总页数
    }
  },
  mounted() {
    if(this.$cookie.get('account') == null){
      this.showLogin = true
    }else{
      this.showLogin = false
    }
    this.getGoodsList()
  },
  methods: {
    getGoodsList(){
      if(this.$route.query.groupId != null){
        this.$fetch('getGoodsList',{groupId:this.$route.query.groupId,pageNo:this.currentPage,pageSize:this.pageSize}).then(res => {
          this.goodsList = res.result.records;
          this.totalNum = res.result.total;
        })
      }else{
        this.$fetch('getGoodsList',{pageNo:this.currentPage,pageSize:this.pageSize}).then(res => {
          this.goodsList = res.result.records;
          this.totalNum = res.result.total;
        })
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;    //动态改变
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.goodsShowIndex = -1;
      this.getGoodsList();
    },
    //跳转产品详情
    toProductDetails(id){
      this.$router.push({name:'ProductDetails',query: {id:id}})
    },
    showPhone(index){
      this.goodsShowIndex = index;
    }
  }
}
</script>
<style>
  @import "../assets/css/style.css";
</style>



// WEBPACK FOOTER //
// src/components/productList.vue